import { Box } from '@mui/material';

import { isMobile } from 'react-device-detect';
import { useSongsStore, useTagsStore } from 'services/hooks';

import theme from 'theme';
import CompanyLogo from 'components/CompanyLogo';
import PageLinks from './components/PageLinks';
import { StyledContainer } from './styled';

const Footer = () => {
  const { areTagsOrFiltersApplied, resetTags } = useTagsStore();
  const { resetSongs } = useSongsStore();

  const handleLogoClick = (): void => {
    if (areTagsOrFiltersApplied) {
      resetTags();
      resetSongs();
    }
  };

  return (
    <Box sx={{ px: 4 }}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          borderTop: `1px solid ${theme.palette.grey[400]}20 `,
        }}
      >
        <StyledContainer>
          <CompanyLogo onClick={handleLogoClick} />
        </StyledContainer>
        <PageLinks />
      </Box>
    </Box>
  );
};

export default Footer;
